import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import _ from 'lodash';
import moment from 'moment';
import * as taxApi from '../../../lib/api/taxbill';

import { useFormik, FormikProvider } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
//mui
import { Alert, Box, Button, Divider, Typography, FormControlLabel, Switch  } from '@mui/material';

import AskDialog from '../../../components/common/dialog/AskDialog';
import SalesBillPlanFormList from '../../../components/projectmng/bill_mng/SalesBillPlanFormList';

import {
  listProjectBuyTaxbills,
  listProjectInitSalesTaxbills,
  listProjectInitSalesTaxbillsPlan,
  listProjectSalesTaxbills,
} from '../../../modules/projectModule/issue-taxbills';
import InvoiceLinModalConatiner from '../../common/form/modal/InvoiceLineModalContainer';
import { listInvoiceApprovalLine } from '../../../modules/empModule/empApproval';
import dayjs from 'dayjs';

const SalesBillFormContainer = ({ project }) => {
  const dispatch = useDispatch();
  const arrayHelperRef = useRef();
  const { enqueueSnackbar } = useSnackbar();

  const [apprUuid, setApprUuid] = useState(null);
  const { invoiceLines } = useSelector(
    ({ empModule }) => ({
      invoiceLines: empModule.employeeApproval.invoiceLines,
     // initSalesTaxbillsPlan: projectModule.issueTaxbills.initSalesTaxbillsPlan,
    }),
  );

  const [visible, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  // 초기 문구를 설정하여 버튼 누르기 전에도 박스가 보이게 합니다.
  const [msg, setMsg] = useState("💡 매출 금액을 수정하시면 [계산서 내역 확인] 버튼을 눌러 금액을 검증 후 저장을 해주세요.");
  const [totalAmtSum, setTotalAmtSum] = useState(0); // 계산된 합계 상태
  const [targetSales, setTargetSales] = useState(0); // 목표 계약금액 상태
  const handleClose = () => {
    setOpenModal(false);
  };
  const onCancle = () => {
    setVisible(false);
  };

  //const [initialValues, setInitialValues] = useState({ purchaseBills: [] });
  // 1. 리덕스에서 데이터 가져오기 (변수명은 프로젝트에 맞게 확인)
  const initSalesTaxbillsPlan = useSelector(state => state.projectModule.issueTaxbills.initSalesTaxbillsPlan);
  
  const initialValues = useMemo(() => {
    return {
      purchaseBills: initSalesTaxbillsPlan || [],
    };
  }, [initSalesTaxbillsPlan]);

  const handleUpdateInvoiceCheck = () => {
    const bills = formik.values.purchaseBills || [];
    if (bills.length === 0) return;

    const getRecursiveRound = (num) => {
        let value = num;
        for (let i = 4; i >= 0; i--) {
            const factor = Math.pow(10, i);
            value = Math.round(value * factor) / factor;
        }
        return Math.round(value);
    };

    const targetExpSales = Number(String(project?.expSales || 0).replace(/,/g, ""));
    const targetExpVat = getRecursiveRound(targetExpSales * 0.1); // 계약금액 기준 최종 목표 부가세
    
    let tempTotalSalAmtSum = 0;
    let tempTotalSalVatSum = 0;

    // 1. [사전 검증] 루프
    for (let i = 0; i < bills.length; i++) {
        const amt = Number(String(bills[i].salAmt || 0).replace(/,/g, ""));
        const vat = isManualVat 
          ? getRecursiveRound(amt * 0.1)
          : Number(String(bills[i].salVat || 0).replace(/,/g, "")); 

        // [추가] 매출 금액이 0인데 부가세가 존재하는 경우 체크
        if (amt === 0 && vat !== 0) {
            setMsg(`❌ 변경 불가: ${i + 1}번 행의 매출 금액이 0원인 경우 부가세가 존재할 수 없습니다.`);
            setIsApplied(false);
            return; // 검증 실패 시 함수 종료
        }

        tempTotalSalAmtSum += amt;
        tempTotalSalVatSum += vat;
    }

    // 2. [차단 로직 1] 매출 금액 합계 초과 체크
    if (tempTotalSalAmtSum > targetExpSales) {
        const overAmt = tempTotalSalAmtSum - targetExpSales;
        setMsg(`❌ 변경 불가: 매출 금액 합계(${tempTotalSalAmtSum.toLocaleString()}원)가 계약금액(${targetExpSales.toLocaleString()}원)을 ${overAmt.toLocaleString()}원 초과했습니다.`);
        return; 
    }

    // 3. [차단 로직 2] 부가세 합계 불일치 체크 (수동 입력 모드일 때만 엄격하게 체크)
    if (!isManualVat && tempTotalSalVatSum !== targetExpVat) {
        const vatDiff = Math.abs(targetExpVat - tempTotalSalVatSum);
        const statusText = tempTotalSalVatSum > targetExpVat ? "초과" : "부족";
        setMsg(`❌ 변경 불가: 부가세 합계(${tempTotalSalVatSum.toLocaleString()}원)가 기준 부가세(${targetExpVat.toLocaleString()}원)를 ${vatDiff.toLocaleString()}원 ${statusText}했습니다.`);
        return; 
    }

    const validIndices = bills
    .map((b, idx) => (Number(String(b.salAmt || 0).replace(/[^0-9.-]/g, "")) !== 0 ? idx : -1))
    .filter(idx => idx !== -1);

    // 4. [본 계산] 루프 - 단수 차이 자동 조정 포함
    let runningBalance = targetExpSales;
    let accumulatedVat = 0; // 마지막 행 조정을 위해 이전 행들의 부가세 합계 추적

    const updatedBills = bills.map((bill, index) => {
        const isLastValid = index === validIndices[validIndices.length - 1];
        const salAmt = Number(String(bill.salAmt || 0).replace(/,/g, ""));
        
        let salVat = 0;
        if (isManualVat===false) {
            // 직접 입력 모드: 입력된 값 그대로 사용
            salVat = Number(String(bill.salVat || 0).replace(/,/g, ""));
        } else {
            // 자동 계산 모드: 단수 차이 조정 로직 적용
            if (isLastValid) {
                // 마지막 행 부가세 = 전체 목표 부가세 - 지금까지 누적된 부가세
                salVat = targetExpVat - accumulatedVat;
            } else {
                // 일반 행 부가세 계산 및 누적
                salVat = getRecursiveRound(salAmt * 0.1);
                accumulatedVat += salVat;
            }
        }
        const totalSalAmt = salAmt + salVat;
        runningBalance = runningBalance - salAmt;

        return {
            ...bill,
            salAmt,
            salVat,
            totalSalAmt,
            salBal: runningBalance 
        };
    });

    // 5. 최종 검증 및 업데이트
    setTotalAmtSum(tempTotalSalAmtSum); 
    setTargetSales(targetExpSales);
    const diff = targetExpSales - tempTotalSalAmtSum;

    if (diff === 0) {
        setMsg(`✅ 금액 일치: 매출 금액 합계와 계약금액이 정확히 일치합니다. 수정을 진행합니다.`);
        formik.setFieldValue('purchaseBills', updatedBills);
        setIsApplied(true);
    }  else if (diff > 0) {
        setMsg(`⚠️ 잔액 발생: 계약금액까지 ${diff.toLocaleString()}원이 남았습니다. 하단의 + 버튼으로 행을 추가하세요.`);
        formik.setFieldValue('purchaseBills', updatedBills);
        setIsApplied(false);
    } else {
        setMsg(`❌ 변경 불가: 매출 금액 합계(${tempTotalSalAmtSum.toLocaleString()}원)가 계약금액(${targetExpSales.toLocaleString()}원)보다 ${diff.toLocaleString()}원 부족합니다.`);
        formik.setFieldValue('purchaseBills', updatedBills);
        setIsApplied(false);
    }
};


  useEffect(() => {
    if (project) {
      //getInitTaxbills(project.prjUuid);
      dispatch(listProjectInitSalesTaxbillsPlan(project.prjUuid));
    }
  }, [project]);
/*
  useEffect(() => {
    if (initSalesTaxbillsPlan) {
      setInitialValues({ purchaseBills: initSalesTaxbillsPlan });
    }
  }, [initSalesTaxbillsPlan]);
*/
  useEffect(() => {
    if (invoiceLines) {
      setApprUuid(invoiceLines[0]?.apprUuid);
    } else {
      dispatch(listInvoiceApprovalLine());
    }
  }, [invoiceLines]);

  // const getInitTaxbills = async (id) => {
  //   try {
  //     const res = await taxApi.getInitTaxbillByPrj(id, 'S');
  //     if (res.data.list) {
  //       const purchaseBills = res.data.list.map((item) => ({
  //         ...item,
  //         buyDiv: 1,
  //       }));
  //       const changeInit = { purchaseBills };
  //       setInitialValues(changeInit);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  let validationSchema = yup.object({
    purchaseBills: yup.array().of(
      yup.object().shape({
        reqCompDt: yup.string('').required('매입일자를 입력하세요'),
        invTxt: yup.string('').required('매입내용을 입력하세요'),
        invAmt: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입금액을 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        invVat: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('부가세를 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        prodCompDt: yup.string('').required('지급예정일자를 입력하세요'),
        buyDiv: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입횟수 입력하세요')
          .min(1, '최소 1 이상을 입력하세요')
          .max(24, '최대 24 이하만 가능합니다'),
      }),
    ),
  });


  // 3. Formik 설정
  const formik = useFormik({
    initialValues: initialValues, // 위에서 정의한 변수 직접 참조
    enableReinitialize: true,      // 이제 이 옵션이 제 역할을 합니다.
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setOpenModal(true);
    },
  });

  const [message, setMessage] = useState('');

  const checkValidation = () => {
    let valid = true;

    if (apprUuid === '' || apprUuid === null) {
      valid = false;
      setMessage('결재선을 선택하세요.');
      return valid;
    }

    //원가산출 체크
    const findItem = formik.values.purchaseBills.find((item) => {
      if (item?.osTran !== 'Y') {
        const perVat = (Number(item?.invVat) / Number(item?.invAmt)) * 100;

        //부가세가 9% 미만 12% 초과
        if (perVat < 9 || perVat > 12) {
          setMessage(
            '부가세가 매입금액의 9% 미만 또는 12% 초과인 항목이 있습니다.등록폼을 확인하십시오',
          );
          return item;
        }

        if (
          Number(item?.billSumTotal) <
          Number(item?.billIssuedTotal) + Number(item?.invAmt)
        ) {
          setMessage(
            '기매입금액과 매입금액의 합계가 총매입금액을 초과하는 항목이 있습니다. 등록폼을 확인하십시오.',
          );
          return item;
        }
      }
    });

    valid = findItem ? false : true;

    return valid;
  };

  const makeData = (values) => {
    const data = [];
    _.forEach(values, (value) => {
      if (Number(value?.invAmt) > 0) {
        value.reqCompDt = moment(value.reqCompDt).format('YYYY-MM-DD');
        value.prodCompDt = moment(value.prodCompDt).format('YYYY-MM-DD');
        data.push(value);
      }
    });
    return data;
  };

  const handleSubmit = () => {
    const valid = checkValidation();
    //console.log(valid, 'valid');
    if (!valid) {
      setVisible(true);
      formik.setSubmitting(false);
      return;
    } else {
      //buyVal 0원인건 보내지 않음.
      formik.setSubmitting(true);

      const saveData = {
        type: 'S',
        data: makeData(formik.values.purchaseBills),
        apprUuid: apprUuid,
      };
      onSave(saveData);
      //console.log(JSON.stringify(saveData));
      formik.resetForm();
    }
  };

  const onSave = async (saveData) => {
    try {
      const res = await taxApi.addIssuedTaxbill(project.prjUuid, saveData);
      if (res.data) {
        //redux
        dispatch(listProjectBuyTaxbills(project.prjUuid));
        dispatch(listProjectSalesTaxbills(project.prjUuid));
        dispatch(listProjectInitSalesTaxbills(project.prjUuid));
        dispatch(listProjectInitSalesTaxbillsPlan(project.prjUuid));
        enqueueSnackbar('매출계산서 저장 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onSaveInvoice = async () => {   
    // 1. [핵심] invYn이 'N'인 항목만 추출 (필터링)
    const targetBills = formik.values.purchaseBills;

    if (targetBills.length === 0) {
      enqueueSnackbar('저장할(미발행) 항목이 없습니다.', { variant: 'info' });
      return;
    }

    // 2. 필터링된 항목만 날짜 포맷팅
    const formattedBills = targetBills.map((bill) => ({
      ...bill,
      salDt: bill.salDt ? dayjs(bill.salDt).format('YYYY-MM-DD HH:mm:ss') : null,
      colDt: bill.colDt ? dayjs(bill.colDt).format('YYYY-MM-DD HH:mm:ss') : null,
    }));

    const saveData = {
      data: formattedBills,
      apprUuid: apprUuid,
    };

    try {
      const res = await taxApi.addIssuedTaxPlanbill(project.prjUuid, saveData);
      if (res.data) {
        dispatch(listProjectInitSalesTaxbillsPlan(project.prjUuid));
        enqueueSnackbar('매출계산서 저장 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== undefined ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setIsApplied(false); 
  };


  if (initSalesTaxbillsPlan && initSalesTaxbillsPlan.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="subtitle2">
          발행할 매출 계산서 내역이 없습니다.
        </Typography>
      </Box>
    );
  }

  
  const isManualVat = (formik.values.purchaseBills?.[0]?.maVat || 'N') === 'Y';
  const bills = formik.values.purchaseBills || [];
  const lastBill = bills[bills.length - 1];
  const isInvCompleted = lastBill?.invYn !== 'N';

  
  const planRowDelete = async (index) => {
    const currentBills = [...(formik.values.purchaseBills || [])];
    
    const deleteData = {
      data: formik.values.purchaseBills[index],
      apprUuid: apprUuid,
    };

    if (formik.values.purchaseBills[index].waitUuid?.includes('newRecord')) {
      return;
    }

    currentBills.splice(index, 1); 
    formik.setFieldValue('purchaseBills', currentBills);

   
    try {
      const res = await taxApi.deleteIssuedTaxPlanbill(project.prjUuid, deleteData);
      if (res.data) {
        dispatch(listProjectInitSalesTaxbillsPlan(project.prjUuid));
        enqueueSnackbar(`${index + 1}번 행이 삭제되었습니다.`, { 
          variant: 'success',
          autoHideDuration: 2000 
        });
      }
    } catch (err) {
      let message =
        err.response !== undefined ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

    // 4. (선택사항) 삭제 후 자동 계산이 필요하다면 실행
    // handleUpdateInvoiceCheck(); 
  };

  return (
    <FormikProvider value={formik}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        
        
            <Box sx={{ mb: 2, minHeight: '40px' }}>
            {msg && (
              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  p: '10px 16px', // 내부 여백
                  borderRadius: '4px', // 모서리 둥글게
                  // '일치' 포함 여부에 따라 배경색 결정 (분홍색 vs 하늘색)
                  backgroundColor: msg.includes("일치") ? '#e3f2fd' : '#fff4f4',
                  border: '1px solid',
                  borderColor: msg.includes("일치") ? '#bbdefb' : '#ffcdd2',
                }}
              >
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: 'bold',
                    // 글자색 결정 (파란색 vs 빨간색)
                    color: msg.includes("일치") ? '#01579b' : '#d32f2f',
                    fontSize: '0.9rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px' // 아이콘과 텍스트 사이 간격
                  }}
                >
                  {msg}
                </Typography>
              </Box>
            )}
          </Box>
          <SalesBillPlanFormList formik={formik} ArrayHelperRef={arrayHelperRef}  isManualVat={isManualVat} setIsApplied={setIsApplied} planRowDelete={planRowDelete} targetExpSales={targetSales} tempTotalSalAmtSum = {totalAmtSum}/>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 0.5 }}>
            <FormControlLabel
              sx={{
                border: '1px solid',
                borderColor: 'divider', // 또는 'grey.400'
                borderRadius: 1,        // 4px
                px: 2,                  // 좌우 패딩
                py: 0.5,                // 상하 패딩
                ml: 0,                  // 기본 여백 제거
                mr: 1,
                '& .MuiTypography-root': { fontSize: '0.875rem' }, // 텍스트 크기 조절,
                
              }}
              control={
                <Switch
                  disabled={isInvCompleted} 
                  size="small"
                  // Y(자동)일 때 스위치가 켜진(ON) 상태가 됨
                  checked={(formik.values.purchaseBills?.[0]?.maVat || 'N') === 'Y'} 
                  onChange={(e) => {
                    const isChecked = e.target.checked; // 스위치를 켜면 true, 끄면 false
                    const newValue = isChecked ? 'Y' : 'N'; // true -> Y(자동), false -> N(수동)
                    
                    const updatedBills = formik.values.purchaseBills.map(bill => ({
                      ...bill,
                      maVat: newValue
                    }));
                    formik.setFieldValue('purchaseBills', updatedBills);
                    setIsApplied(false);
                  }}
                />
              }
              label={formik.values.purchaseBills?.[0]?.maVat === 'Y' ? "부가세 자동 적용" : "부가세 직접 입력"}
            />
            <Button
                disabled={isInvCompleted} 
                variant="outlined" 
                onClick={handleUpdateInvoiceCheck}
                sx={{ fontWeight: 'bold' }}
            >
                계산서 내역 확인
            </Button>
            <Button 
              variant="contained" 
              onClick={onSaveInvoice} // 실제 저장 함수 연결
              disabled={!isApplied} // [핵심] 변경 적용 안 됐으면 비활성화
              sx={{ 
                fontWeight: 'bold',
                // 비활성화 시에도 위치를 유지하려면 별도 스타일 불필요
              }}
          >
              계산서 내역 저장
          </Button>
        </Box>
         
        </Box>
        
        <AskDialog
          visible={visible}
          title="등록 오류"
          description={message}
          onCancle={onCancle}
          onConfirm={onCancle}
        />
        {openModal && (
          <InvoiceLinModalConatiner
            title="결재라인 선택"
            open={openModal}
            approvalLines={invoiceLines}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        )}
    </FormikProvider>
  );
};

export default SalesBillFormContainer;
